import { useState } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CommentComposer({ postId, parentId, onPosted, placeholder = "Add a comment…", autoFocus }) {
  const { user } = useAuth();
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!user) { window.dispatchEvent(new Event("omni:open-auth")); return; }
    if (!body.trim()) return;
    setBusy(true);
    try {
      await axios.post(`${API}/forums/posts/${postId}/comments`, { body, parent_id: parentId });
      setBody("");
      onPosted?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not comment");
    } finally {
      setBusy(false);
    }
  };

  const testid = parentId ? `forum-reply-composer-${parentId}` : "forum-comment-composer";
  const submitTestid = parentId ? `forum-reply-submit-${parentId}` : "forum-comment-submit";

  return (
    <div data-testid={testid} className="bg-[#0A0A0A] border-2 border-zinc-900 p-3">
      <textarea
        value={body}
        onChange={(e) => setBody(e.target.value.slice(0, 2000))}
        rows={parentId ? 2 : 3}
        autoFocus={autoFocus}
        placeholder={placeholder}
        className="w-full bg-transparent text-white outline-none resize-y placeholder-neutral-600"
      />
      <div className="flex items-center justify-between mt-1">
        <span className="text-[10px] text-neutral-600">{body.length}/2000</span>
        <button
          onClick={submit}
          disabled={busy || !body.trim()}
          className="btn-omni btn-red disabled:opacity-40 text-xs"
          data-testid={submitTestid}
        >
          {busy ? "Posting…" : (parentId ? "Reply" : "Comment")}
        </button>
      </div>
    </div>
  );
}
